import * as React from 'react';
import {useState} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import Stack from "@mui/material/Stack";
import {CircularProgress} from "@mui/material";
import Typography from "@mui/material/Typography";

import Box from "@mui/material/Box";
import {useAuth} from "oidc-react";
import {FAILED, LOADING, postRequest, SUCCESS} from "../../httpClient";

export const DownloadStudyNoteModal = ({ open, setOpen, note }) => {

    const handleClose = () => {
        setOpen();
        setStatus('');
    };

    const auth = useAuth();
    const [status, setStatus] = useState('');

    const download = () => {
        setStatus(LOADING)

        let body = {
            bibleVerse: "-",
            email: auth.userData.profile.email,
            fileName: `${note.title}.pdf`,
            firstName: auth.userData.profile.given_name,
            lastName: auth.userData.profile.family_name,
            noteTitle: note.title,
            notes: note.note,
            recipient: auth.userData.profile.sub,
            studyNoteId: note.id
        }

        let token = auth?.userData?.access_token;

        postRequest(`/v3/documents/study-note`, token, JSON.stringify(body))
            .then(resp => {
                if (resp.ok) {
                    setStatus(SUCCESS);
                    return resp;
                }
                throw resp
            })
            .catch(() => {
                setStatus(FAILED);
                setInterval(() => setStatus(''),6000);
            });
    }

    return (
        <div>
            <Dialog open={open} onClose={handleClose} maxWidth={'md'}>
                <DialogTitle>{`${note.title}`}</DialogTitle>
                <DialogContent>
                    <div style={{ marginTop: '1rem'}}/>
                    {
                        status === LOADING ?
                            <Stack alignItems={"center"}>
                                <div style={{ marginTop: '1rem'}}/>
                                <CircularProgress color={"secondary"}/>
                            </Stack>
                            :
                            status === SUCCESS ?
                                <Stack>
                                    <Typography color={'primary'} component={"div"} variant={'h5'} sx={{ mt: '1rem', textAlign: 'center'}}>
                                        {`You will get a notification when your file is ready.`}
                                    </Typography>
                                </Stack>
                                :
                                <div>
                                    <Stack direction={'row'} spacing={3} display={"flex"} alignItems={"center"} justifyContent={"center"}>
                                        <Box sx={{ minWidth: 200 }}>
                                            <Typography color={'inherit'} component={"div"} variant={'h6'} sx={{ textAlign: 'center'}}>
                                                Your note will be generated into a pdf file.
                                                You will get a notification when your file is ready.
                                            </Typography>
                                        </Box>

                                    </Stack>

                                </div>
                    }

                </DialogContent>

                {
                    status === SUCCESS ?
                        <DialogActions>
                            <Button onClick={handleClose}>Close</Button>
                        </DialogActions>
                        :
                        <DialogActions>
                            <Button onClick={handleClose}>cancel</Button>
                            <Button onClick={download}>download</Button>
                        </DialogActions>
                }

            </Dialog>
        </div>
    );
}
